
import { storage } from './storage.js'

export const uuid = function(prefix="") {
	return prefix+Date.now().toString(36)
}

export const uuid2 = function(prefix="") {
	return prefix+Date.now().toString(36)+Math.random().toString(36).substring(2)
}

export const getIbyUUID = function(list, uuid) {
	let i = null
	for (let x in list) {
		if (list[x].uuid==uuid) {
			i = x
		}
	}
	return i
}
export function numberExchange(value){
  if (!value) return 0
  // 获取整数部分
  const intPart = Math.trunc(value)
  // 整数部分处理，增加,
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  // 预定义小数部分
  let floatPart = ''
  // 将数值截取为小数部分和整数部分
  const valueArray = value.toString().split('.')
  if (valueArray.length === 2) {
    // 有小数部分
    floatPart = valueArray[1].toString() // 取得小数部分
    return intPartFormat + '.' + floatPart
  }
  return intPartFormat + floatPart
}
export const getUserToken = function() {
	let token = storage.get("QMY_USER_TOKEN")
	return token || null
}

export const getUserInfo = function(key) {
	let userinfo = storage.get("QMY_USERINFO")
	if (!userinfo) {
		return null
	}
	if (!key) {
		return userinfo
	}
	if (!userinfo.hasOwnProperty(key)) {
		return null
	}
	return userinfo[key]
}

export const isLogined = function() {
	let token = storage.get("QMY_USER_TOKEN")
	let userinfo = storage.get("QMY_USERINFO")
	return (token && userinfo) ? true : false
}

export const loginOut = function() {
	storage.remove("QMY_USER_TOKEN")
	storage.remove("QMY_USERINFO")
}
/**
	获取URL参数
	@param string url：完整的url地址
	return json {
		json:拆分的参数信息
		str:未拆分不含域名的参数信息
	}
*/
export const getUrlParam = function(url) {
	var cs_url = url.split('?')[1];                //获取?之后的参数字符串
	var cs_arr = cs_url.split('&');                    //参数字符串分割为数组
	var cs={};
	for(var i=0;i<cs_arr.length;i++){         //遍历数组，拿到json对象
	  cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
	}
	return {json:cs,str:cs_url};
}






/* element-plus 上传组件 el-upload 自定义上传请求 -S */ 

class UploadAjaxError extends Error {
  name = 'UploadAjaxError'
  status
  method
  url

  constructor(message, status, method, url) {
    super(message)
    this.status = status
    this.method = method
    this.url = url
  }
}
function getError(
  action,
  option,
  xhr
) {
  let msg
  if (xhr.response) {
    msg = `${xhr.response.error || xhr.response}`
  } else if (xhr.responseText) {
    msg = `${xhr.responseText}`
  } else {
    msg = `fail to ${option.method} ${action} ${xhr.status}`
  }

  return new UploadAjaxError(msg, xhr.status, option.method, action)
}

function getBody(xhr) {
  const text = xhr.responseText || xhr.response
  if (!text) {
    return text
  }
  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}
export const fileUpload=function(option){
	const xhr = new XMLHttpRequest()
	const action = option.action
	
	if (xhr.upload) {
		xhr.upload.addEventListener('progress', (evt) => {
			const progressEvt = evt
			progressEvt.percent = evt.total > 0 ? (evt.loaded / evt.total) * 100 : 0
			option.onProgress(progressEvt)
		})
	}
	
	const formData = new FormData()
	if (option.data) {
		option.data['key']=uuid2("q");
		for (const [key, value] of Object.entries(option.data)) {
			if (Array.isArray(value) && value.length) formData.append(key, ...value)
			else formData.append(key, value)
		}
	}
	formData.append(option.filename, option.file, option.file.name)
	
	xhr.addEventListener('error', () => {
		option.onError(getError(action, option, xhr))
	})
	
	xhr.addEventListener('load', () => {
		if (xhr.status < 200 || xhr.status >= 300) {
			return option.onError(getError(action, option, xhr))
		}
		
		option.onSuccess(getBody(xhr))
	})
	
	xhr.open(option.method, action, true)
	
	if (option.withCredentials && 'withCredentials' in xhr) {
		xhr.withCredentials = true
	}
	
	const headers = option.headers || {}
	if (headers instanceof Headers) {
		headers.forEach((value, key) => xhr.setRequestHeader(key, value))
	} else {
		for (const [key, value] of Object.entries(headers)) {
			if (isNil(value)) continue
			xhr.setRequestHeader(key, String(value))
		}
	}
	console.log(formData,xhr,option)
	xhr.send(formData)
	return xhr
}

/* element-plus 上传组件 el-upload 自定义上传请求 -E */ 